module.exports = __webpack_public_path__ + "static/media/GIC.1e89be3b.png";